import request from "@/utils/request";

export function index(params) {
  return request({
    url: "/business-areas",
    method: "get",
    params
  });
}
export function update(id, data) {
  return request({
    url: "/business-areas/" + id,
    method: "put",
    data
  });
}
export function show(id) {
  return request({
    url: "/business-areas/" + id,
    method: "get"
  });
}
export function store(data) {
  return request({
    url: "/business-areas",
    method: "post",
    data
  });
}
export function destroy(id) {
  return request({
    url: "/business-areas/" + id,
    method: "delete"
  });
}
